import { ContentContext } from "../../../../utils/contexts";
const { Typography } = window.Material;


class NoResultPage extends React.PureComponent {
  render() {
    const { currentSite, loadingContent, initialText } = this.context;

    return (
      <div className={`no-items${loadingContent ? ' blurred' : ''}`}>
        <Typography variant="h5">{currentSite.nodeRef ? window.Alfresco.messages.global['edocat.text.no-results'] : initialText || window.Alfresco.messages.global['edocat.global.path-picker.initial-message']}</Typography>
      </div>
    );
  }
}

NoResultPage.contextType = ContentContext;

export default NoResultPage;